import apiFetch from "../utils/fetch";

export function getLookerEmbedUrl(data, callback, errorcallback) {
    apiFetch('/api/looker/embed-url', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        }
    });
}

export function generateURL(data, user, callback, errorcallback) {
    let url_data = {
        dashboard_id: data.dashboard_id,
        user_id: data.user_id,
        user_attributes: user.user_attributes,
        override_filters: data.override_filters,
        object: data.object
    };
    getLookerEmbedUrl(url_data, (responseData) => {
        const signedUrl = responseData.signedUrl;
        callback(signedUrl);
    }, errorcallback);
}

export function generateUrlFilters(data){
    if (data.override_filters === true){
        let url = new URL(data.object.absoluteUrl);
        let filters = "&filter_config=" + url.searchParams.get("filter_config");
        return filters;
    }
    else return "";
}

